import { HStack, PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { CreateCrtPeriodDetailsDialog } from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import {
  channelContributionsSearchSchema,
  useCreateChannelContributions,
} from '@/hooks/queries/crt/useChannelContributions'
import { Button } from '@repo/ui/components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ChannelContributionsDataTable from './-components/ChannelContributionsDataTable'

export const Route = createFileRoute('/_auth/_modules/crt/volume-forecasts/channel-contributions/')(
  {
    component: RouteComponent,
    validateSearch: (search) => channelContributionsSearchSchema.parse(search),
  },
)

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateChannelContributions({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('channelContributions.pageHeader')}</PageHeader>
        <HStack gap="sm">
          <Button type="button" variant="secondary" asChild>
            <Link to="/crt/volume-forecasts">
              <ArrowLeftIcon className="size-4" />
              {t('actions.backToVolumeForecasts')}
            </Link>
          </Button>
          <PermissionsGuard required={['crt_volume_forecasts_configure']}>
            <CreateCrtPeriodDetailsDialog
              isOpen={isOpen}
              onOpenChange={setIsOpen}
              triggerLabel={t('channelContributions.createButton')}
              title={t('createChannelContributionsDialog.title')}
              nameLabel={t('createChannelContributionsDialog.name.label')}
              namePlaceholder={t('createChannelContributionsDialog.name.placeholder')}
              isPending={isPending}
              onSubmit={({ name, description, crtPeriod }) =>
                mutate({ name, description, crtPeriod })
              }
            />
          </PermissionsGuard>
        </HStack>
      </Spread>

      <Card>
        <CardContent className="pt-6">
          <VStack gap="md">
            <ChannelContributionsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
